import gql from "@/api/gql.js"
import { query, mutation } from "./queries.js"
import resolveApiErrors from "@/api/resolveApiErrors"

export default {
	async pdfTemplates(variables) {
		const res = await gql({
			query: query.pdfTemplates,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "templates"
		})
	},

	async listTemplates(variables) {
		const res = await gql({
			query: query.listTemplates,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "templates"
		})
	},

	async templateWithDrawings(variables) {
		const res = await gql({
			query: query.templateWithDrawings,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "templates"
		})
	},

	// list existing uploaded files
	async listFileTemplates(variables) {
		const res = await gql({
			query: query.listFileTemplates,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithoutList",
			res,
			resKey: "fileListing"
		})
	},

	async createPdfDrawingTemplate(variables) {
		const res = await gql({
			query: mutation.createPdfDrawingTemplate,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "createPdfDrawingTemplate"
		})
  },
  
	async createWkhtmltopdfTemplate(variables) {
		const res = await gql({
			query: mutation.createWkhtmltopdfTemplate,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "createWkhtmltopdfTemplate"
		})
	},

	async updatePdfDrawingTemplate(variables) {
		const res = await gql({
			query: mutation.updatePdfDrawingTemplate,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "updatePdfDrawingTemplate"
		})
  },
  
	async updateWkhtmltopdfTemplate(variables) {
		const res = await gql({
			query: mutation.updateWkhtmltopdfTemplate,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "updateWkhtmltopdfTemplate"
		})
	},

	async createPdfDrawing(variables) {
		const res = await gql({
			query: mutation.createPdfDrawing,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "addPdfDrawing"
		})
	},

	async removePdfDrawing(variables) {
		const res = await gql({
			query: mutation.removePdfDrawing,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "removePdfDrawing"
		})
	},
	async updatePdfDrawing(variables) {
		const res = await gql({
			query: mutation.updatePdfDrawing,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "updatePdfDrawing"
		})
	},

	async createEmailMjmlTemplate(variables) {
		const res = await gql({
			query: mutation.createEmailMjmlTemplate,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "createEmailMjmlTemplate"
		})
	},

	async updateEmailMjmlTemplate(variables) {
		const res = await gql({
			query: mutation.updateEmailMjmlTemplate,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "updateEmailMjmlTemplate"
		})
	},

	async deleteTemplate(variables) {
		const res = await gql({
			query: mutation.deleteTemplate,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "deleteTemplate"
		})
	},

	async addEmailAttachmentTemplate(variables) {
		const res = await gql({
			query: mutation.addEmailAttachmentTemplate,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "addEmailAttachmentTemplate"
		})
	},

	async removeEmailAttachmentTemplate(variables) {
		const res = await gql({
			query: mutation.removeEmailAttachmentTemplate,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "removeEmailAttachmentTemplate"
		})
	},

	async updateEmailAttachmentTemplate(variables) {
		const res = await gql({
			query: mutation.updateEmailAttachmentTemplate,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "updateEmailAttachmentTemplate"
		})
	},

	async sendNotification(variables) {
		const res = await gql({
			query: mutation.sendNotification,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "sendNotification"
		})
	},

	async policies(variables) {
		const res = await gql({
			query: query.policies,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "policies"
		})
  },
  
  async renderEmailMjmlTemplate(variables) {
		const res = await gql({
			query: query.renderEmailMjmlTemplate,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithoutList",
			res,
			resKey: "renderEmailMjmlTemplate"
		})
  },

  async renderWkhtmltopdfTemplate(variables) {
		const res = await gql({
			query: query.renderWkhtmltopdfTemplate,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithoutList",
			res,
			resKey: "renderWkhtmltopdfTemplate"
		})
  },

  async renderPdfDrawingTemplate(variables) {
		const res = await gql({
			query: query.renderPdfDrawingTemplate,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithoutList",
			res,
			resKey: "renderPdfDrawingTemplate"
		})
  }
  
}
